var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHaieLibre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 422.66910420475324,
    viewBox: "0, 0, 400,422.66910420475324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0",
    d: "M0.000 211.200 L 0.000 422.400 33.200 422.400 L 66.400 422.400 66.400 211.200 L 66.400 0.000 33.200 0.000 L 0.000 0.000 0.000 211.200 M134.000 211.200 L 134.000 422.400 167.000 422.400 L 200.000 422.400 200.000 211.200 L 200.000 0.000 167.000 0.000 L 134.000 0.000 134.000 211.200 M267.600 211.200 L 267.600 422.400 300.400 422.400 L 333.200 422.400 333.200 211.200 L 333.200 0.000 300.400 0.000 L 267.600 0.000 267.600 211.200 ",
    stroke: "none",
    fill: "#fcfcc4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M66.599 211.200 C 66.599 327.470,66.644 375.035,66.700 316.900 C 66.756 258.765,66.756 163.635,66.700 105.500 C 66.644 47.365,66.599 94.930,66.599 211.200 M133.200 211.200 C 133.200 351.733,133.334 422.400,133.600 422.400 C 133.866 422.400,134.000 351.733,134.000 211.200 C 134.000 70.667,133.866 0.000,133.600 0.000 C 133.334 0.000,133.200 70.667,133.200 211.200 M200.199 211.200 C 200.199 327.470,200.244 375.035,200.300 316.900 C 200.356 258.765,200.356 163.635,200.300 105.500 C 200.244 47.365,200.199 94.930,200.199 211.200 M266.800 211.200 C 266.800 351.733,266.934 422.400,267.200 422.400 C 267.466 422.400,267.600 351.733,267.600 211.200 C 267.600 70.667,267.466 0.000,267.200 0.000 C 266.934 0.000,266.800 70.667,266.800 211.200 M333.399 211.200 C 333.399 327.470,333.444 375.035,333.500 316.900 C 333.556 258.765,333.556 163.635,333.500 105.500 C 333.444 47.365,333.399 94.930,333.399 211.200 ",
    stroke: "none",
    fill: "#1c641c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M66.800 211.200 L 66.800 422.400 100.000 422.400 L 133.200 422.400 133.200 211.200 L 133.200 0.000 100.000 0.000 L 66.800 0.000 66.800 211.200 M200.400 211.200 L 200.400 422.400 233.600 422.400 L 266.800 422.400 266.800 211.200 L 266.800 0.000 233.600 0.000 L 200.400 0.000 200.400 211.200 M333.600 211.200 L 333.600 422.400 366.800 422.400 L 400.000 422.400 400.000 211.200 L 400.000 0.000 366.800 0.000 L 333.600 0.000 333.600 211.200 ",
    stroke: "none",
    fill: "#1c641c",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaieLibre);
export default __webpack_public_path__ + "static/media/haie-libre.4c673544e77d8e9ad01358922fd46f98.svg";
export { ForwardRef as ReactComponent };